export const SET_LOADING = 'SET_LOADING';
export const SET_EMAIL_AVAILABLE = 'SET_EMAIL_AVAILABLE';
